import React, { useState, useEffect } from 'react';
import pb, { currentUser as pbUser, currentRole } from './pb';
import Login from './components/Login';
import Dashboard from './erp/chaste-proto.jsx';

function buildSession() {
  const u = pbUser();
  if (!u) return null;
  const email = u.email || '';
  return {
    id: u.id,
    email,
    name: u.name || email.split('@')[0] || 'User',
    role: currentRole(),
  };
}

export default function App() {
  const [screen, setScreen] = useState('loading');
  const [session, setSession] = useState(null);

  useEffect(() => {
    function apply() {
      if (pb.authStore.isValid) {
        setSession(buildSession());
        setScreen('app');
      } else {
        setSession(null);
        setScreen('login');
      }
    }
    apply();
    const unsub = pb.authStore.onChange(apply);
    return () => unsub();
  }, []);

  function handleLogout() {
    pb.authStore.clear();
    window.location.reload();
  }

  if (screen === 'loading') {
    return (
      <div style={loadingStyle}>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#F9FAFB', letterSpacing: '-0.04em' }}>
          denim<span style={{ color: '#818CF8' }}>erp</span>
        </div>
        <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 13 }}>Loading…</div>
      </div>
    );
  }

  if (screen === 'login') return <Login onLogin={() => setScreen('app')} />;

  if (!session) return null;
  return <Dashboard session={session} onLogout={handleLogout} />;
}

const loadingStyle = {
  minHeight: '100vh',
  background: 'linear-gradient(160deg, #0F172A 0%, #1E1B4B 100%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: "'DM Sans', sans-serif",
  gap: 12,
};
